import { EmailIntegration } from "@/schema"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { deleteEmailIntegration, getAuthUri, updateEmailIntegration } from "./api"

interface GetAuthUriParams {
  provider: string
  returnTo?: string
  source?: string
  emailIntegrationId?: string
}

export function useGetAuthUriMutation() {
  const getContext = useApiContext()

  return useMutation({
    mutationFn: async (params: GetAuthUriParams) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return getAuthUri(context, params)
    },
  })
}

export function useUpdateEmailIntegrationMutation() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: Partial<EmailIntegration> }) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return updateEmailIntegration(context, id, data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["email_integrations"] })
    },
  })
}

export function useDeleteEmailIntegrationMutation() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return deleteEmailIntegration(context, id)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["email_integrations"] })
    },
  })
}
